import { memo } from 'react';

import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import { TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

const ACTION_TYPE = ACTION_TYPES.update_fields;

export const Node = memo((node: TravellerJourneyNode<typeof ACTION_TYPE>) => {
  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        node={node}
        label={getActionLabel(ACTION_TYPE)}
        descriptionText={node.data?.description}
      >
        <NodeActions node={node} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
});
